import { IconAlertInfoOutlined } from '@hulu-react-style-components/icons';
import React, { memo } from 'react';

import HeaderIconTooltip from '../../../../../common/TraffickingTable/HeaderIconTooltip';
import bem from '../../../../../utils/bem';

type Props = Readonly<{
  label: string;
  tooltipId: string;
  tooltipMessage: string;
  showTooltip: boolean;
  disabled?: boolean;
}>;

const [, element] = bem('buffer-cell');

function BufferLabel({ label, tooltipId, tooltipMessage, showTooltip, disabled }: Props): React.JSX.Element {
  return (
    <span className={element('label', disabled ? 'disabled' : '')}>
      {label}
      {showTooltip && (
        <HeaderIconTooltip tooltipId={tooltipId} tooltipMessage={tooltipMessage} isDisabled={false}>
          <IconAlertInfoOutlined className={element('info-icon')} aria-label={`${label.toLowerCase()}-info`} />
        </HeaderIconTooltip>
      )}
    </span>
  );
}

export default memo(BufferLabel);
